module.exports = __webpack_public_path__ + "img/52.25e93041.png";